export const getOTPHeader = otp => {
    return otp
        ? {
              headers: { 'hubplanner-mfa-otp': otp },
          }
        : undefined;
};